export const Areas = {
    checkout: 'checkout-area',
    orderSummary: "ordersummary-area",
    assemblyChat: "assemblychat-area"
};